import "./AvailabilitySection.css";

function AvailabilitySection({
  formData,
  updateField,
}) {
  return (
    <div className="bakery-form-section">

      <h3 className="section-title">
        Availability & Stock
      </h3>

      <div className="bakery-form-grid">

        <div className="form-group">
          <label>Stock Quantity</label>

          <input
            type="number"
            min="0"
            placeholder="Enter stock quantity"
            value={formData.stock || ""}
            onChange={(e) =>
              updateField("stock", e.target.value)
            }
          />
        </div>

        <div className="form-group">
          <label>Stock Status</label>

          <select
            value={formData.stockStatus || "In Stock"}
            onChange={(e) =>
              updateField("stockStatus", e.target.value)
            }
          >
            <option value="In Stock">In Stock</option>
            <option value="Low Stock">Low Stock</option>
            <option value="Out of Stock">Out of Stock</option>
          </select>
        </div>

      </div>

      <div className="checkbox-grid">

        <label className="checkbox-item">

          <input
            type="checkbox"
            checked={formData.availableToday}
            onChange={(e) =>
              updateField("availableToday", e.target.checked)
            }
          />

          <span>Available Today</span>

        </label>

        <label className="checkbox-item">

          <input
            type="checkbox"
            checked={formData.isAvailable}
            onChange={(e) =>
              updateField("isAvailable", e.target.checked)
            }
          />

          <span>Currently Available</span>

        </label>

      </div>

    </div>
  );
}

export default AvailabilitySection;